jQuery(function($){

  function detectOSandBrowser(){
    // Browser detection
    var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    var isFirefox = /Firefox/.test(navigator.userAgent);
    var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    var isOpera = /OPR/.test(navigator.userAgent);
    var isIE = /Trident/.test(navigator.userAgent);

    // OS detection
    var isWindows = /Windows/.test(navigator.userAgent);
    var isMac = /Macintosh/.test(navigator.userAgent);
    var isLinux = /Linux/.test(navigator.userAgent);
    var isIphone = /iPhone/.test(navigator.userAgent) && !window.MSStream;

    // Add classes to body tag
    if (isChrome) {
        $('body').addClass('on-chrome');
    } else if (isFirefox) {
        $('body').addClass('on-firefox');
    } else if (isSafari) {
        $('body').addClass('on-safari');
    } else if (isOpera) {
        $('body').addClass('on-opera');
    } else if (isIE) {
        $('body').addClass('on-ie');
    }

    if (isWindows) {
        $('body').addClass('on-windows');
    } else if (isMac) {
        $('body').addClass('on-mac');
    } else if (isLinux) {
        $('body').addClass('on-linux');
    } else if (isIphone) {
        $('body').addClass('on-mac on-iphone');
    }
    //$('.copyright__content').html( $('body').attr('class') )
  }
  detectOSandBrowser();
  
  function getUrlVars(){
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
  }
  
  $(document).on('click', function(event) {
    if (!$(event.target).is('.mega-menu')) {
      $('body').removeClass('mega-menu-active');
    }
  });
  $(document).on("click",".mega-menu",function() {
    if($('body').hasClass('mega-menu-active')){
      $('body').removeClass('mega-menu-active');
    } else {
      $('body').addClass('mega-menu-active');
    }
  });

  $('summary.list-menu__item').click(function(){
    if($(this).hasClass('current-open-menu') && $(this).data('link')!=undefined && $(this).data('link')!='#'){
      window.location = $(this).data('link');
      return false;
    } else {
      $(this).addClass('current-open-menu')
    }
  });

  const soi_cards = $('.search-override-items .gl-card-holder');
  if(soi_cards.length){

    var sq = getUrlVars()['q'];
    if(sq!=undefined && sq!=''){
      $('.page-loader').show();
      
      sq = sq.toLowerCase();

      soi_cards.each(function(){
          var soi_card = $(this);
          var sqw = $(this).data('keywords').split(',');
          $.each(sqw,function(i,kw){
             if(sq == kw){
               window.stop();
               window.location.href = soi_card.data('url');
             }
          });
     });
      $('.page-loader').hide();
      
    }

    $('main-search form').submit(function(){
      var sq = $(this).find('input[name="q"]').val();
      if(sq!=undefined && sq!=''){
        var redirect = '';
        soi_cards.each(function(){
          var soi_card = $(this);
          var sqw = $(this).data('keywords').split(',');
          $.each(sqw,function(i,kw){
             if(sq == kw){
               redirect = true;
               window.location.href = soi_card.data('url');
             }
          });
        });
        if(redirect == true){
          return false;
        }
      }
    });

    $('body').on('DOMNodeInserted', '.globo-selected-items', function() {
      responsiveUpdates();
    });
    
    $('body').on('DOMNodeInserted', '.gl-fullscreen-initial-content', function() {
      var me = $(this);
      var sq = $(".gl-d-searchbox-input").val().toLowerCase();
      var card_added = false;
      
      if(sq != ''){
        var index = 1
        soi_cards.each(function(){
          var soi_card = $(this);
          var sqw = $(this).data('keywords').split(',');
          $.each(sqw,function(i,kw){
             if(sq == kw){
               $('.gl-fullscreen-suggestions').addClass('force-hide-notice');
               if(!me.find('.gl-card-item-'+index).length){
                  me.find('.gl-fullscreen-results__content').prepend(soi_card.html());
                  $('.gl-list__title').css({'opacity':'0','visibility':'hidden'});
                  $('.gl-card').hide();
                  $('.gl-card-force-show').show();
                  card_added = true
               }
             }
          });
          index++;
        });
      }
      if(card_added = false){
        $('.gl-fullscreen-suggestions').removeClass('force-hide-notice');
        $('.gl-card').show();
        $('.gl-list__title').css({'opacity':'1','visibility':'visibile'});
      }
      
      
      /* if(sq=='jade' || sq=='jadeite' ){
        $('.gl-fullscreen-suggestions').addClass('force-hide-notice');
  
        var html = '<div class="jade-product flex-col"><div class="_inner"><a href="/pages/jadeite"><img src="//asprey-1.myshopify.com/cdn/shop/files/jadeite-nav.jpg?v=1706713185&amp;width=1024" alt="" srcset="//asprey-1.myshopify.com/cdn/shop/files/jadeite-nav.jpg?v=1706713185&amp;width=352 352w, //asprey-1.myshopify.com/cdn/shop/files/jadeite-nav.jpg?v=1706713185&amp;width=832 832w, //asprey-1.myshopify.com/cdn/shop/files/jadeite-nav.jpg?v=1706713185&amp;width=1024 1024w" width="1024" height="719" class="img-fluid"><h3>Imperial Jadeite Collection</h3></a></div></div>';
  
        if(!me.find('.jade-product').length)
          me.find('.gl-fullscreen-results__content').prepend(html)
      } else {
        $('.gl-fullscreen-suggestions').removeClass('force-hide-notice');
      } */
      
    });
  }

  $(document).on("click",".product-call_for_pricing,.product-call_to_buy",function() {
    var $me = $(this);

    /* add product fields to form hidden fields */
    var $pop_section = $('.quick-popup-section[data-index="2"]');
    $pop_section.find('.field,.contact__button').show();
    $pop_section.find('.msg-success,.msg-error').hide();
      
    $pop_section.find('.field_product-name').val( $('product-info').find('.product__title h1').text() );
    $pop_section.find('.field_product-sku').val( $('product-info').find('.product__sku').text() );
    
    $('#concierge-drawer').addClass('open');
    $pop_section.addClass('active');
    $('.concierge-drawer-items').hide();

    if($me.hasClass('on-popup')){
      $('.product-popup-modal-cites').removeAttr('open');
      $('body').removeClass('overflow-hidden');
    }
    
    return false;
  });

  $(document).on("click","#button-open-concierge",function() {
    $('#concierge-drawer').addClass('open');
    return false;
  });
  $(document).on("click","#button-close-concierge",function() {

    $('.field_product-name,.field_product-sku').val('');
    
    if($('.quick-popup-section.active').length){
      $('.quick-popup-section').removeClass('active');
      $('.concierge-drawer-items').show();
    } else {
      $('#concierge-drawer').removeClass('open');
    }
    return false;
  });

  $(document).on("click",".concierge-drawer-items > li > a",function() {
    var $activeIndex = $(this).data('index');
    $('.quick-popup-section[data-index="'+$activeIndex+'"]').addClass('active');
    $('.concierge-drawer-items').hide();
    return false;
  });

  $(document).on("click",".boutiques-countries > li > a,.tab-back-location",function() {
    var $country = $(this).data('for');
    $('.tab-boutiques-counrties,.tab-content').hide();
    $('.boutiques-locations-wrap').addClass('active').show();
    $('.tab-'+$country).show();
    $('.tab-location-details').html('').hide();
    return false;
  });

  $(document).on("click",".tab-back",function() {
    $('.boutiques-locations-wrap,.tab-content').removeClass('active').hide();
    $('.tab-boutiques-counrties').show();
    return false;
  });

  $(document).on("click",".boutiques-locations > li > a",function() {
    $('.boutiques-locations-wrap,.tab-content').removeClass('active').hide();
    $('.tab-location-details').html( $( $(this).data('content') ).html() ).show();

    var gMap = $('.tab-location-details').find('.google-map');
    if(gMap.length){
      gMap.attr('id','conciergeMap')
      let latitude = gMap.data('latitude');
      let longitude = gMap.data('longitude');
      if(latitude && longitude){
        initGoogleMap('conciergeMap',latitude,longitude)
      }
    }
    return false;
  });

  $(document).on("click",".customer-menu .account-link",function() {
    $('.header-account-form').hide();
    $($(this).data('href')).show();
    return false;
  });

  $(document).on("click",".product-show_cites",function() {
    //$($(this).data('form')).find('.add-to-cart-hidden').trigger('click');
    $('.product-popup-modal-cites').attr('open','');
    $('body').addClass('overflow-hidden');
    return false;
  });

  $(document).on("click",".popup-add-to-cart",function() {
    $($(this).data('form')).find('.main-buy-button').removeClass('product-show_cites').attr('type', 'submit').trigger('click');
    $('.product-popup-modal-cites').removeAttr('open');
    $('body').removeClass('overflow-hidden');
    $($(this).data('form')).find('.main-buy-button').addClass('product-show_cites').attr('type', 'button');
    return false;
  });

  //$('.main-buy-button').click(function(){ alert('clicked'); })

  $(document).on("click",".sorting-close,.sort-options li,#sorting-overlay",function() {
    $('#sorting-tree,#sorting-overlay').toggleClass('open');
  });  

  $(document).on("click",".sort-by label",function() {
    if($(window).width()>767) return true;
    $('#sorting-tree,#sorting-overlay').toggleClass('open');
  }); 

  $(document).on("change",".is-select-field select",function() {
    if($(this).val()!=''){
      $(this).parent().addClass('is-selected');
    } else {
      $(this).parent().removeClass('is-selected');
    }
  });

  $('.footer-block--menu .footer-block__heading').click(function(){
    let $parent = $(this).parent();
    if($parent.hasClass('open')){
      $(this).parent().removeClass('open');
      $(this).parent().find('.footer-block__details-content').stop(true).slideUp('fast');
    } else {
      $('.footer-block--menu').removeClass('open');
      $('.footer-block--menu').find('.footer-block__details-content').stop(true).slideUp('fast');
      
      $(this).parent().addClass('open')
      $(this).parent().find('.footer-block__details-content').stop(true).slideDown('fast');
    }
    
  });
  

  function setMegaSubNavHeight($dropElement){

    let $dropContent = $dropElement.parent().find('.mega-menu__content');
    
    var $h = 0;
    let subNavList = $dropContent.find('.mega-menu__list>li');
    subNavList.each(function(){
      var $me = $(this);
      var $first_ul = $me.find('ul').first();
      $first_ul.addClass('first-ul');
      $(this).find('.first-ul').height('auto');
      
      if($first_ul.height()>$h) $h = $first_ul.height();
    });
    $dropContent.find('.first-ul').height($h);
  }

  $(document).on("click",'a[href="#size-guide"]',function() {
    $('.product-popup-modal-SizeGuide').attr('open','');
    return false;
  });
  $(document).on("click",'a[href="#contact-us"]',function() {
    var $me = $(this);
    $('.product-popup-modal-SizeGuide').removeAttr('open');

    var $pop_section = $('.quick-popup-section[data-index="2"]');
    $pop_section.find('.field,.contact__button').show();
    $pop_section.find('.msg-success,.msg-error').hide();

          
    $pop_section.find('.field_product-name').val( '');
    $pop_section.find('.field_product-sku').val( '');

    
    $('#concierge-drawer').addClass('open');
    $pop_section.addClass('active');
    $('.concierge-drawer-items').hide();
    
    return false;
  });

  $(document).on("click",'a[href="#care_instructions"]',function() {
    $('#PopupModal-CareInstructions').attr('open','');
    var $html = $(this).parent().find('.care-instructions-content').html();
    $('.care-instructions-detail').html( $html )
    return false;
  });

  $('.close-edit-address').click(function(){
    $('.edit-button,.add-button').attr('aria-expanded',false);
    return false;
  });

  var $addressCountry = $('.addresses select[name="address[country]"]');
  if($addressCountry.length){
    $addressCountry.each(function(){
      var $ac = $(this);
      $ac.prepend('<option value="---" data-provinces="[]"></option>')
    })
  }

  $('.addresses form').submit(function(){
    if($(this).find('select[name="address[country]"]').val()=='---'){
      alert('Please select country');
      return false
    }
    return true;
  })
  
  //$('.product-popup-modal-cites').attr('open','');

  /*$(document).on("click","summary.list-menu__item",function() {
    var $de = $(this);
    setTimeout(function(){
      setMegaSubNavHeight( $de );
    },10)
  });*/

  /*$(document).on("click",".force-download",function() {
    var fileName = $(this).attr('href').split('/').pop()
    SaveToDisk($(this).attr('href'), fileName);
    return false;
  });*/

  function SaveToDisk(fileURL, fileName) {
    // for non-IE
    if (!window.ActiveXObject) {
        var save = document.createElement('a');
        save.href = fileURL;
        save.target = '_blank';
        save.download = fileName || 'unknown';

        var evt = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': false
        });
        save.dispatchEvent(evt);

        (window.URL || window.webkitURL).revokeObjectURL(save.href);
    }

    // for IE < 11
    else if ( !! window.ActiveXObject && document.execCommand)     {
        var _window = window.open(fileURL, '_blank');
        _window.document.close();
        _window.document.execCommand('SaveAs', true, fileName || fileURL)
        _window.close();
    }
  }

  function responsiveUpdates(){
    $('.site-GB .selected-item > span, .site-GB .gf-block-title span').each(function(){
      if($(this).text()=='Color'){
        $(this).addClass('colour-text');
      }
    });
    $('.site-GB .selected-item > span,.site-GB .gf-block-title span').show();
    
    setTimeout(function(){

      if($('.product-grid-container ul.product-grid li').length == 0){
        $('.gf-summary b').text('0');
      }
      $('.order-history tr td>div').height('auto');
      $('.order-history tr').each(function(){
        var $td = $(this);
        var $h = 0;
        $td.find('td>div').each(function(){
          if($(this).height() > $h) $h = $(this).height();
        });
        $td.find('td>div').height($h);
      });

      $('.site-GB .selected-item > span, .site-GB .gf-block-title span').each(function(){
      if($(this).text()=='Color'){
        $(this).addClass('colour-text');
      }
    });
    $('.site-GB .selected-item > span, .site-GB .gf-block-title span').show();
      
    },100);
  }
  responsiveUpdates();
  $(window).on("load resize",function(e){
    responsiveUpdates();
  });

  $(window).on("load",function(e){
    setTimeout(function(){
      //console.log('FIRT E',$('body').html());

     function replaceFirstOccurrenceInBody(oldString, newString) {
        $("body *:contains('" + oldString + "')").each(function() {
            var html = $(this).html();
            var newText = html.replace(oldString, newString);
            //$(this).html(newText);
            return false; // Stop after replacing the first occurrence
        });
    }
    
    // Call the function with the strings to replace
    replaceFirstOccurrenceInBody("{", "");
      
    },100)
    
  });

    var $_loading_page = '';
  var next_page = 'empty';
  var next_loading = false;
  function ScrollExecute() {
    var windowHeight = $(window).height();
    var scrollPosition = $(window).scrollTop();
    var productGrid = $('#product-grid');
    if($('#product-grid').length == 0) return;
    
    var gridBottom = productGrid.offset().top + productGrid.outerHeight();
     if( (windowHeight + scrollPosition) >= gridBottom && next_loading == false && $('.infinite_next a').length && $_loading_page != next_page ) {   
       next_loading = true;
         $('.load-indicator').addClass('loading');
         var next_page = $('.infinite_next a').attr('href');
         $_loading_page = next_page;
         $.ajax({
              type: 'GET',
              url: next_page,
              success: function(data) {
                var filteredData = $(data).find("#product-grid").html();
                if(filteredData){
                  filteredData = $(filteredData);
                  productGrid.append( filteredData );
                  responsiveUpdates();
                }

                var next_new_page = $(data).find(".infinite_next a");
                if(next_new_page.length){
                  $('.infinite_next a').attr('href',next_new_page.attr('href'));
                } else {
                  $('.infinite_next').remove();
                }
                
                $_loading_page = '';
                next_loading = false;
                $('.load-indicator').removeClass('loading');
              },
              dataType: "html"
          });
         
     }
   }
  
   $(window).scroll(function(){
     setTimeout(function(){ ScrollExecute(); },200);
   });

  $(document).on("click",'.sort-by-selected',function() {
    $(this).parent().stop(true).toggleClass('open');    
  });
  $(document).on("click",'.sort-by-options li',function() {
    $('.sort-by-selected label').text( $(this).find('.facet-checkbox__text').text() );
    $(this).parent().stop(true).toggleClass('open');    
  });

  $(document).on("click",'.filter-accordion-header',function() {
    $(this).parent().stop('true').toggleClass('accordion-open')
    $(this).parent().find('.filter-accordion-body').stop('true').slideToggle();
  });

  $(document).on("click",'.filter-close',function() {
    $('.mobile-facets__disclosure').removeClass('menu-opening').removeAttr('open');
  });

  function setCookie(name, value, days) {
    var end = new Date();
    var expirationTime = end.getTime() + days * 24 * 60 * 60 * 1000; // Convert days to milliseconds
    end.setTime(expirationTime);
    document.cookie = name + '=' + value + '; expires=' + end.toGMTString();
  }
  function getCookie(name) {
    var nameEQ = name + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  var $newsletterPopup = $('#newsletter-popup')
  if($newsletterPopup.length){
    var popup_opened = false
    setTimeout(function(){
      if (!getCookie('newsletter-popup-closed')) {
        tryOpenPopup();
      }      
    },2000);

    function tryOpenPopup(){
      if(popup_opened == true) return;
      
      setTimeout(function(){
        $('#newsletter-popup ._inner > div').each(function(){
          if($(this).html()!=''){
            $('body').addClass('newsletter-popup-open');
            $newsletterPopup.fadeIn('slow');
            popup_opened = true;
            return;
          }
        });
        if(popup_opened == false){
          //console.log('TRYING OPEN AGAIN!')
          tryOpenPopup();
        }
      },3000);
    }
    
    $('.close-newsletter-popup').click(function(){
      setCookie('newsletter-popup-closed','yes',7);
      $('body').removeClass('newsletter-popup-open');
      $newsletterPopup.fadeOut('slow');
      return false;
    });
  }

  
});

function priceRangeFilter(){
    initiatePriceSlider("#price-range-filter",'price-min-input','price-max-input','#FacetFiltersForm');
    initiatePriceSlider("#price-range-filter-mobile",'price-min-input-mobile','price-max-input-mobile','#FacetFiltersFormMobile');

    if($(".mobile-facets__list").length){
      $(".mobile-facets__list").mCustomScrollbar({
          theme:"dark"
      });
    }
    if($(".mobile-facets__main").length){
      $(".mobile-facets__main").mCustomScrollbar({
          theme:"dark"
      });
    }
    
  }
  
  function initiatePriceSlider(slider_id,min_ip_class,max_ip_class,form_id){
    if($(slider_id).length == 0) return;
    
    $(slider_id).slider({tooltip:'hide',});
    $(slider_id).on("slide", function(slideEvt) {
      const min_input = document.getElementsByClassName(min_ip_class);
      const max_input = document.getElementsByClassName(max_ip_class);
      const facetFilterForm = document.querySelector(form_id);
  
      var current_min = min_input[0].value;
      var current_max = max_input[0].value;
  
      var new_min = slideEvt.value[0];
      var new_max = slideEvt.value[1];
      if(current_min != new_min){
        min_input[0].value = slideEvt.value[0];
        //$('.price-min-val').text('$'+slideEvt.value[0]);
        facetFilterForm.dispatchEvent(new Event('input'));
      }
  
      if(current_max != new_max){
        max_input[0].value = slideEvt.value[1];
       //$('.price-max-val').text('$'+slideEvt.value[1]);
        facetFilterForm.dispatchEvent(new Event('input'));
      }
    });
  }
  if($('body').hasClass('template-collection') || $('body').hasClass('template-search')){
    priceRangeFilter();
  }

  $(document).on("click",".product-swatches input",function() {
    var $ip = $(this);
    if($ip.attr('name')=='Color' || $ip.attr('name')=='Colour' || $ip.attr('name')=='色'){
      $('.product-swatches .selected-value').html($ip.val());
      if($('input[name="__Color"]').length){
        $('input.variant-option-input[value="'+ $ip.val() +'"]').trigger('click');
      }
      if($('input[name="__色"]').length){
        $('input.variant-option-input[value="'+ $ip.val() +'"]').trigger('click');
      }
    }
  });